<template>
  <div class="exam-page">

    <exam-header><span class="font-weight-regular">Certificate Exam</span></exam-header>

    <div>
      <v-layout  v-if="questions.length > 0">

        <v-flex text-xs-center >
          <v-stepper v-model="e1" class="question-stepper" style="box-shadow: none;">
            <v-stepper-items>
              <v-stepper-content
                class="pa-0"
                v-touch="{
                              left: () => swipe('Left'),
                              right: () => swipe('Right')
                            }"
                v-for="(question, index) in questions" :key="'view_'+index"
                :step="index + 1"
              >
                <div class="d-flex"
                     :style="{height: getContainerHeight()}"
                     style="flex-direction: column;">
                <v-img class="grey lighten-3"
                       v-for="(resource, index1) in question.examResources"
                       :key="index1"
                       v-if="resource.type === 1"
                       contain
                       :height="imageHeight"
                       :max-height="imageHeight"
                       transition="fade-transition"
                       :src="`${apiUrl}/ws/playerservice/deck/${resource.deckId}/resource/${resource.fileName}.${resource.extension}`">
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>

                    </v-layout>
                  </template>

                </v-img>
                  <v-flex class="pb-2">

                <v-flex text-xs-left class="scrollbar scroll-style-15 px-4 py-2"
                        v-for="(resource, index2) in question.examResources"
                        :key="index2"
                        v-if="resource.type === 0"
                        v-html="resource.textContent"
                        ></v-flex>
                  </v-flex>
                <!---------- BUTTONS --------------------->
                  <v-flex class="align-end d-flex pa-2">
                    <v-layout column>
                      <v-flex>
                        <v-btn-toggle
                          v-model="formatting"
                          class="answers-toggle elevation-0"
                        >
                          <v-layout wrap class="button-layout">
                            <v-flex :class="question.answers.length > 2 ?'xs12 pb-0 pt-2':'xs12 pb-0'"
                                    :key="x"
                                    class="button-flex px-2"
                                    v-if="question.answers.length > 1"
                                    v-for="(answer,x) in question.answers">

                              <v-btn block :value="answer.id"
                                     class="exam-option-btn"
                                     @click="updateAnswerTxt(answer)" outline
                                     color="secondary darken-4" active-class="option-active">{{answer.text}}
                                {{answer.correctEntry === true && isDev?'*':''}}
                              </v-btn>

                            </v-flex>
                          </v-layout>
                        </v-btn-toggle>

                        <v-layout wrap align-center justify-center>
                          <v-flex class="xs12" py-0 v-if="question.answers.length <= 1">

                            <v-text-field
                              :autofocus=true
                              outline
                              @input="updateFitb($event, n)"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs8 class="text-xs-left  mt-2 px-2 grey--text">
                            Ques. <strong>{{answered + 1}}</strong> of <strong>{{totalQues}}</strong>
                          </v-flex>
                          <v-flex xs4  class="text-xs-right mt-2">
                            <v-btn color="primary darken-1"
                                   :small="$vuetify.breakpoint.name === 'xs'"
                                   :loading="submittingScoreDialog"
                                   :disabled="answerTxt === ''"
                                   @click="validateAnswer(question, index)">
                              Submit
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <!---------- /BUTTONS --------------------->
</div>
              </v-stepper-content>

              <v-layout style="width:100%" row class="nav-btn pa-0" >

                <v-flex xs6 class="text-xs-left stepper-left-button" >
                  <v-btn  color="grey lighten-2" v-if="e1 !== 1" class="elevation-5" @click.prevent="prevSlide" fab small dark>
                    <span class="notranslate"><v-icon  x-large >chevron_left</v-icon></span>
                  </v-btn>
                </v-flex>
                <v-flex xs6 class="text-xs-right">
                  <v-btn color="grey lighten-2" v-if="questions.length !== e1" class="elevation-5"
                         @click.prevent="nextSlide" fab small dark>
                    <span class="notranslate"><v-icon x-large >chevron_right</v-icon></span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-items>
          </v-stepper>

        </v-flex>
      </v-layout>

      <v-layout fill-height v-else align-center justify-center>
        <v-flex style="margin-top:300px;">
          <v-layout
            fill-height
            align-center
            justify-center
            ma-0
          >
            <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular><span class="title font-weight-light">&nbsp;{{loadingExamTxt}}</span>

          </v-layout>
        </v-flex>
      </v-layout>








      <v-dialog
        v-if="examCompleteDialogFail"
        v-model="examCompleteDialogFail"
        :width="$store.getters.getAppWidth - 10"
      >
        <v-card>
          <v-card-text>
            <p>You scored <strong>{{typeof examCompleteData.finalExam === 'undefined' ? '' : examCompleteData.finalExam.score}}</strong> and did not pass the exam. No badge or certificate
              has been issued. Check your email for full result details.</p>
            <p>Based on your exam scores these are your learning needs.</p>

            <ul>
              <li v-if="examCompleteData.highLearningNeedLevels"
                  class="red--text"><strong >HIGH</strong> <span class="black--text">learning need on level {{examCompleteData.highLearningNeedLevels}}</span></li>
              <li v-if="examCompleteData.mediumLearningNeedLevels"
                  class="orange--text"><strong>MEDIUM</strong> <span  class="black--text">learning need on level {{examCompleteData.mediumLearningNeedLevels}}</span></li>
            </ul>
            <br>
            <p>
              To enable a new exam attempt, you must study and use the <strong>QUIZ</strong> on levels marked as a HIGH learning need.
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              @click="goToProgramLevels"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <badge-button
        page="exam"
        :badgeDialog="displayBadgeDialogValue"></badge-button>

    </div>
  </div>

</template>

<script>
import ExamHeader from '../layouts/ExamHeader'
import BadgeButton from './widgets/BadgeButton'

const TF = 0
const FITB = 1
const MC = 2
export default {
  components: { ExamHeader, BadgeButton },
  data () {
    return {
      displayBadgeDialogValue: 0,
      loadingExamTxt: '',
      badgeNCertificate: 'badge',
      formatting: [],
      apiUrl: process.env.API_URL,
      level: parseInt(this.$route.params.level),
      groupId: parseInt(this.$route.params.groupId),
      deckId: parseInt(this.$route.params.deckId),
      answerTxt: '',
      currentQuestionId: -1,
      currentQuestion: '',
      badgeImage: 'front',
      frontImg: '',
      certificateImg: '',
      certificateMailSend: false,
      loadingSendCertificateMail: false,
      totalQues: this.$store.getters['exam/getExamQuestionsCount'],
      isDev: process.env.NODE_ENV === 'development',
      scrollHeight: 0
    }
  },
  mounted: function () {
    this.scrollHeight = this.$store.getters.getAppHeight - 60
  },
  computed: {
    imageHeight: function () {
      return this.iPad ? 350 : 250
    },
    iPad () {
      return this.$store.getters.getIPad
    },
    answered: function () {
      return this.totalQues - this.$store.getters['exam/getExamQuestions'].length
    },
    user: {
      get: function () {
        return this.$store.getters['user/getUserDetails']
      },
      set: function () {
        // setting db object
      }
    },
    examCompleteData: function () {
      return this.$store.getters['exam/getExamCompleteData']
    },
    submittingScoreDialog: {
      get: function () {
        return this.$store.getters['exam/getSubmittingScoreDialogStatus']
      },
      set: function (status) {
        this.$store.commit('exam/setSubmittingScoreDialogStatus', status)
      }
    },
    examCompleteDialogFail: {
      get: function () {
        return this.$store.getters['exam/getExamCompleteDialogFailStatus']
      },
      set: function (status) {
        this.$store.commit('exam/setExamCompleteDialogFailStatus', status)
      }
    },
    examCompleteDialogPass: {
      get: function () {
        return this.$store.getters['exam/getExamCompleteDialogPassStatus']
      },
      set: function (status) {
        this.$store.commit('exam/setExamCompleteDialogPassStatus', status)
      }
    },
    e1: {
      get: function () {
        return parseInt(this.$route.params.step)
      },
      set: function (step1) {
      }
    },
    questions: {
      get: function () {
        return this.$store.getters['exam/getExamQuestions']
      },
      set: function (data) {
        this.$store.commit('exam/setExamQuestions', data)
      }
    },
    appHeight: {
      get: function () {
        return this.scrollHeight
      },
      set: function (height) {
        this.scrollHeight = height
      }
    },
    group () {
      return this.$store.getters['course/getGroups'].find(group => group.groupId === this.groupId)
    }
  },
  created () {
    this.e1 = 1
    this.loadingExamTxt = 'loading exam...'
    this.submittingScoreDialog = false
    this.examCompleteDialogPass = false
    if (this.questions.length < 1) {
      this.$router.push({name: 'ProgramLevels', params: {deckId: this.deckId, groupId: this.groupId}})
    }
  },
  methods: {
    swipe (direction) {
      if (direction === 'Left') {
        this.nextSlide()
      } else if (direction === 'Right') {
        this.prevSlide()
      }
    },
    displayBadgeDialog () {
      this.displayBadgeDialogValue = new Date().getTime()
    },
    sendCertificateMail () {
      this.loadingSendCertificateMail = true
      this.$store.dispatch('exam/sendCertificateMail').then(response => {
        this.$store.commit('flashSuccess', 'Mail sent successfully..')
        this.certificateMailSend = true
        this.loadingSendCertificateMail = false
      })
    },
    goToProgramLevels () {
      this.examCompleteDialogFail = false
      this.$router.push({name: 'ProgramLevels', params: {deckId: this.deckId, groupId: this.groupId}})
    },
    // getExamDialog () {
    //   this.$store.dispatch('exam/markFinalExamComplete', 1127)
    // },
    updateFitb (val) {
      this.answerTxt = val
    },
    textContentStyleObject (question) {
      // const breakpoint = this.$vuetify.breakpoint.name
      let buttonHeight = 110
      switch (question.type) {
        case TF: buttonHeight = 110
          break
        case FITB: buttonHeight = 190
          break
        case MC: buttonHeight = 230
          break
      }
      // if (breakpoint === 'xs') {
      //   buttonHeight += 50
      // }
      let height = (this.appHeight - this.imageHeight - buttonHeight) + 'px'
      return {
        height
      }
    },
    updateAnswerTxt (answer) {
      if (this.currentQuestionId !== answer.question_id) {
        this.formatting = []
        this.answerTxt = ''
        this.currentQuestionId = answer.question_id
      }
      setTimeout(() => {
        if (typeof this.formatting !== 'undefined') {
          this.answerTxt = this.formatting.toString()
        }
      }, 50)
    },
    validateAnswer (question, qIndex) {
      if (this.questions.length <= 1) {
        this.loadingExamTxt = 'Finalizing exam...'
      }

      this.$store.dispatch('exam/validateAnswer', {
        question,
        qIndex,
        answer: this.formatting.length !== 0 ? this.formatting : this.answerTxt
      })
    },
    firstSlide () {
      this.$router.push({name: 'Exam', params: {deckId: this.deckId, groupId: this.groupId}})
    },
    nextSlide () {
      if (this.questions.length !== this.e1) {
        const e1 = this.e1 + 1
        this.$router.push({name: 'Exam', params: {deckId: this.deckId, groupId: this.groupId, step: e1}})
      }
    },
    prevSlide () {
      if (this.e1 !== 1) {
        const e1 = this.e1 - 1
        this.$router.push({name: 'Exam', params: {deckId: this.deckId, groupId: this.groupId, step: e1}})
      }
    },
    getBadgeImages () {
      this.$store.dispatch('exam/fetchBadgeFrontImage', {deckId: this.group.decks[0].regId, userId: this.user.id}).then(data => {
        let prefix = 'data:' + data.headers['content-type'] + ';base64,'
        let img = Buffer.from(data.data, 'binary').toString('base64')
        this.frontImg = prefix + img
      })
      this.$store.dispatch('exam/fetchCertificateImage', {deckId: this.group.decks[0].regId, userId: this.user.id}).then(data => {
        let prefix = 'data:' + data.headers['content-type'] + ';base64,'
        let img = Buffer.from(data.data, 'binary').toString('base64')
        this.certificateImg = prefix + img
      })
      // this.$store.dispatch('exam/fetchBadgeBackImage', {deckId: this.group.decks[0].regId, userId: this.user.id}).then(data => {
      //   let prefix = 'data:' + data.headers['content-type'] + ';base64,'
      //   let img = Buffer.from(data.data, 'binary').toString('base64')
      //   this.backImg = prefix + img
      // })
    },
    getContainerHeight () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom) - 60px)'
      } else {
        return 'calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom) - 60px)'
      }
    }
  },
  watch: {
    questions (newVal) {
      this.formatting = []
      this.answerTxt = ''
    },
    e1 (newVal) {
      this.formatting = []
      this.answerTxt = ''
    },
    formatting (newVal) {
      if (typeof newVal === 'undefined') {
        this.answerTxt = ''
      }
    },
    examCompleteData (newVal) {
      this.frontImg = ''
      this.certificateImg = ''
      this.getBadgeImages()
    },
    examCompleteDialogPass (newVal) {
      if (newVal === true) {
        this.displayBadgeDialog()
      }
    }
  }
}
</script>

<style scoped>
  .sfh-login-form{
    padding-top: 0!important;
  }
  .exam-page .v-btn {
    text-transform: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Exam.vue